jQuery(function ($) {

    $('.home2__slider-js').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true
    });

    if (window.innerWidth >= 768) {
        $("body").niceScroll();
    }

    document.addEventListener('wpcf7submit', function (event) {
        if (window.innerWidth >= 768) {
            $("body").niceScroll().resize();
        }
    }, false);

    $('.menu__btn-js').on('click', function () {
        if (window.innerWidth >= 768) {
            $("body").niceScroll().resize();
        }

        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $('.menu__mobile').slideUp();
        } else {
            $(this).addClass('active');
            $('.menu__mobile').slideDown();
        }
    });


    if ($('body').hasClass('page-template-template-home')) {

        let scrollTop = document.documentElement.scrollTop;

        if (scrollTop == 0) {
            $('a[title="header"]').parent().addClass('current');
        }

        var sections = $('.section')
                , nav = $('.top-bar')
                , nav_height = nav.outerHeight();

        $(window).on('scroll', function () {
            var cur_pos = $(this).scrollTop();

            sections.each(function () {
                var top = $(this).offset().top - nav_height,
                        bottom = top + $(this).outerHeight();

                if (cur_pos >= top && cur_pos <= bottom) {
                    nav.find('.scrollLink').removeClass('current');
                    sections.removeClass('active');

                    $(this).addClass('active');
                    nav.find('a[title="' + $(this).attr('id') + '"]').parent().addClass('current');
                }
            });
        });

        nav.find('.scrollLink a').on('click', function () {


            if (window.innerWidth < 768) {
                $('.menu__btn-js').removeClass('active');
                $('.menu__mobile').css('display', 'none');

                var $el = $(this)
                        , id = $el.attr('title');

                $('html, body').animate({
                    scrollTop: $('#' + id).offset().top
                }, 500);


            } else {
                var $el = $(this)
                        , id = $el.attr('title');

                $('html, body').animate({
                    scrollTop: $('#' + id).offset().top - nav_height
                }, 500);
            }



            return false;
        });

//        $(document).ready(function () {
//            $(document).on("scroll", onScroll);
//
//            //smoothscroll
//            $('.scrollLink a').on('click', function (e) {
//                e.preventDefault();
//                $(document).off("scroll");
//
//                $(this).each(function () {
//                    $(this).removeClass('active');
//                })
//                $(this).addClass('active');
//
//                var target = $(this).attr('title'),
//                        menu = target;
//                $target = $(target);
//                $('html, body').stop().animate({
//                    'scrollTop': $target.offset().top + 2
//                }, 500, 'swing', function () {
//                    window.location.hash = target;
//                    $(document).on("scroll", onScroll);
//                });
//            });
//        });
//
//        function onScroll(event) {
//            var scrollPos = $(document).scrollTop();
//            $('#menu-center a').each(function () {
//                var currLink = $(this);
//                var refElement = $(currLink.attr("href"));
//                if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
//                    $('#menu-center ul li a').removeClass("active");
//                    currLink.addClass("active");
//                } else {
//                    currLink.removeClass("active");
//                }
//            });
//        }

    }

});